import { Link } from "react-router-dom";
import { Storefront, Clock, Scissors, ChartLine } from "@phosphor-icons/react";
import { KMark } from "@/components/KMark";

export default function ProWelcome() {
  return (
    <div className="max-w-3xl mx-auto px-5 py-16" data-testid="pro-welcome-page">
      <div className="flex justify-center mb-6"><KMark size={64} /></div>
      <p className="overline text-center mb-3">Welcome to KUTZ</p>
      <h1 className="font-display text-5xl md:text-6xl tracking-tighter text-center">Turn your skill into a business.</h1>
      <p className="text-cream/70 text-center mt-6 max-w-lg mx-auto leading-relaxed">
        Create your own Studio. Choose when you work. Show people what you can do. Earn on your terms.
      </p>
      <div className="mt-12 grid md:grid-cols-3 gap-4">
        {[
          { i: Storefront, t: "Your Studio", d: "Not an employment application — an actual business you own." },
          { i: Clock, t: "Your hours", d: "Open Wednesday and Thursday nights? Great. Only you decide." },
          { i: ChartLine, t: "Your earnings", d: "Working platform fee is 8%. Repeat bookings are fee-free." },
        ].map(({ i: Icon, t, d }) => (
          <div key={t} className="border border-cream/10 p-5">
            <Icon size={22} color="#C5A059" />
            <p className="font-display text-lg tracking-tight mt-3">{t}</p>
            <p className="text-xs text-cream/70 mt-2 leading-relaxed">{d}</p>
          </div>
        ))}
      </div>
      <div className="mt-12 text-center">
        <Link to="/pro/onboarding" data-testid="cta-create-studio" className="btn-gold px-8 py-4 rounded-full text-xs uppercase tracking-[0.3em] font-semibold inline-flex items-center gap-2">
          Create My Studio
        </Link>
        <p className="text-[10px] uppercase tracking-[0.25em] text-cream/40 mt-4">Save progress anytime</p>
      </div>
    </div>
  );
}
